const authenticationPageContent = [
  {
    "content": "API authentication",
    "type": "title"
  },
  {
    "content": "How to authenticate API requests",
    "type": "subtitle"
  },
  {
    "type": "separator"
  },
  {
    "type": "text",
    "content": "Each request must be authenticated using your api key\nIn requests include the following header:\n\n"
  },
  {
    "type": "text",
    "content": "<code>api-key</code> - your API key\n\n"
  },
  {
    "type": "separator"
  },
  {
    "type": "semi_title",
    "content": "For development purposes use the following demo API credentials\n"
  },
  {
    "type": "text",
    "content": "<code>api-key: <b>AS_wWa7hTkJNQEzmzv4ZpGh</b></code>\n"
  },
  {
    "type": "subtitle",
    "content": "Regarding obtaining your own API credentials please fill in our onboarding form <a href=\"https://airtable.com/shr8t4cPYIu8Inawo\" target=\"_blank\">airtable.com/shr8t4cPYIu8Inawo</a>"
  },
  {
    "type": "separator"
  }
]

export default authenticationPageContent
